import { API } from 'aws-amplify';
import { TUTORING_V2_URL_APPEND } from 'constants';

export const getV2TimeBlocks = async ({
  page,
  pageSize,
  ascending,
  teacherId,
  subjectId,
  activeOnly,
  paginationKey,
}) => {
  const response = await API.get(
    'delta-api',
    `${TUTORING_V2_URL_APPEND}/timeblocks`,
    {
      queryStringParameters: {
        page,
        ascending,
        teacherId,
        subjectId,
        activeOnly,
        paginationKey,
        limit: pageSize,
      },
    },
  );

  return response;
};

export const postV2TimeBlocks = async (payload, blockType) => {
  const myPayload = {
    body: payload,
  };

  await API.post(
    'delta-api',
    `${TUTORING_V2_URL_APPEND}/timeblocks/${blockType}`,
    myPayload,
  );
};

export const deleteV2TimeBlocks = async (timeBlockId) => {
  await API.del(
    'delta-api',
    `${TUTORING_V2_URL_APPEND}/timeblocks/${timeBlockId}`,
  );
};
